export enum Color {
  VEXIZA_GRAY = '#6E7191',
  VEXIZA_BLUE = '#194AB2',
  VEXIZA_GREEN = '#00C507',
  VEXIZA_RED = '#FF0000',
  SIMULATION_LOADING = '#199CE0',
  SIMULATION_ERROR = '#FF3234',
  SIMULATION_PRECIPITATION_COLOR = '#008FFB',
  SIMULATION_TEMPERATURE_COLOR = '#FEB019',
  SIMULATION_RELATIVE_HUMIDITY_COLOR = '#00E396',
  SIMULATION_WIND_SPEED_COLOR = '#775DD0',
  SIMULATION_DEFAULT_COLOR = '#FF4558',
  SIMULATION_DARK_GRAY = '#4D4F66',
  BLACK = '#000000'
}
